export const FILTER_URL_TRANSLATIONS = {
  'en-GB': {
    queryStringParams: {
      medium: 'medium',
      subMedium: 'sub-medium',
      orientation: 'orientation',
      size: 'size',
      style: 'style',
      subject: 'subject',
      subSubject: 'sub-subject',
      color: 'color',
      region: 'region',
      gender: 'gender',
      stage: 'stage',
      price: 'price',
      practice: 'practice',
      initial: 'initial',
      ships: 'ships',
      born: 'born',
      countries: 'countries',
      width: 'width',
      height: 'height',
      layout: 'layout',
      sort: 'sort',
    },
    filtersInUrl: {
      art: {
        inPath: {
          subMedium: {
            'digital-1': 'digital',
            'fabric-1': 'fabric',
            'ink-1': 'ink',
            'paper-1': 'paper',
            'mixed-media-1': 'mixed-media',
            'mixed-media-2': 'mixed-media',
            'mixed-media-3': 'mixed-media',
          },
          subSubject: {
            'flower-1': 'flower',
            'london-1': 'london',
            'new-york-1': 'new-york',
          },
        },
        price: {
          UP: 'UP',
        },
        color: {
          colourful: 'colourful',
          'black-white': 'black-white',
          white: 'white',
          grey: 'grey',
          black: 'black',
          'maroon-neutral': 'maroon-neutral',
          orange: 'orange',
          yellow: 'yellow',
          green: 'green',
          blue: 'blue',
          purple: 'purple',
          pink: 'pink',
          red: 'red',
        },
        medium: {
          collage: 'collage',
          digital: 'digital',
          drawings: 'drawings',
          installation: 'installation',
          paintings: 'paintings',
          photography: 'photography',
          prints: 'prints',
          sculpture: 'sculpture',
        },
        subMedium: {
          photo: 'photo',
          'mixed-media-2': 'mixed-media-2',
          oil: 'oil',
          digital: 'digital',
          screenprint: 'screenprint',
          transfer: 'transfer',
          fabric: 'fabric',
          'fabric-1': 'fabric-1',
          'mixed-media-1': 'mixed-media-1',
          'paper-1': 'paper-1',
          chalk: 'chalk',
          charcoal: 'charcoal',
          ink: 'ink',
          'ink-1': 'ink-1',
          pastel: 'pastel',
          pencil: 'pencil',
          acrylic: 'acrylic',
          airbrush: 'airbrush',
          gouache: 'gouache',
          tempera: 'tempera',
          watercolour: 'watercolour',
          'black-white': 'black-white',
          crayon: 'crayon',
          colour: 'colour',
          'digital-1': 'digital-1',
          'mixed-media': 'mixed-media',
          encaustic: 'encaustic',
          etching: 'etching',
          lino: 'lino',
          lithograph: 'lithograph',
          marble: 'marble',
          'mixed-media-3': 'mixed-media-3',
          mono: 'mono',
          woodcut: 'woodcut',
          bronze: 'bronze',
          ceramic: 'ceramic',
          clay: 'clay',
          enamel: 'enamel',
          glass: 'glass',
          kinetic: 'kinetic',
          metal: 'metal',
          paper: 'paper',
          pinhole: 'pinhole',
          plastic: 'plastic',
          resin: 'resin',
          vector: 'vector',
          wood: 'wood',
          stone: 'stone',
        },
        stage: {
          new: 'new',
          emerging: 'emerging',
          established: 'established',
        },
        orientation: {
          L: 'landscape',
          P: 'portrait',
          S: 'square',
        },
        style: {
          abstract: 'abstract',
          'abstract-expressionism': 'abstract-expressionism',
          'abstract-marble': 'abstract-marble',
          'art-deco': 'art-deco',
          cartoon: 'cartoon',
          conceptual: 'conceptual',
          'colour-field': 'colour-field',
          cubism: 'cubism',
          'geometric-abstract': 'geometric-abstract',
          dada: 'dada',
          expressionistic: 'expressionistic',
          graphic: 'graphic',
          minimalistic: 'minimalistic',
          mosaic: 'mosaic',
          figurative: 'figurative',
          geometric: 'geometric',
          illustrative: 'illustrative',
          impressionistic: 'impressionistic',
          photorealism: 'photorealism',
          'pop-art': 'pop-art',
          realistic: 'realistic',
          stencil: 'stencil',
          'street-art': 'street-art',
          surrealist: 'surrealist',
        },
        subject: {
          architecture: 'architecture',
          botanical: 'botanical',
          celebrities: 'celebrities',
          documentary: 'documentary',
          'science-technology': 'science-technology',
          seascapes: 'seascapes',
          'transport-auto': 'transport-auto',
          typography: 'typography',
          urban: 'urban',
          maps: 'maps',
          fantasy: 'fantasy',
          food: 'food',
          animals: 'animals',
          cityscapes: 'cityscapes',
          fashion: 'fashion',
          landscapes: 'landscapes',
          music: 'music',
          nature: 'nature',
          nudes: 'nudes',
          politics: 'politics',
          portraits: 'portraits',
          spirituality: 'spirituality',
          sports: 'sports',
          'still-life': 'still-life',
          underwater: 'underwater',
          wildlife: 'wildlife',
        },
        subSubject: {
          bird: 'bird',
          cat: 'cat',
          cow: 'cow',
          dog: 'dog',
          fish: 'fish',
          horse: 'horse',
          'hong-kong': 'hong-kong',
          'london-1': 'london-1',
          'new-york-1': 'new-york-1',
          paris: 'paris',
          singapore: 'singapore',
          beach: 'beach',
          rural: 'rural',
          sky: 'sky',
          london: 'london',
          'new-york': 'new-york',
          flower: 'flower',
          'flower-1': 'flower-1',
          tree: 'tree',
          leaves: 'leaves',
          female: 'female',
          male: 'male',
          religion: 'religion',
          athletics: 'athletics',
          cycling: 'cycling',
          football: 'football',
          food: 'food',
          airplane: 'airplane',
          bike: 'bike',
          car: 'car',
          ship: 'ship',
          train: 'train',
          yacht: 'yacht',
        },
        sort: {
          ontherise: 'ontherise',
          latest: 'latest',
          alltimetop: 'alltimetop',
          price: 'price',
          default: 'default',
        },
        layout: {
          sq: 'sq',
          fl: 'fl',
        },
      },
      artist: {
        inPath: {
          born: {
            AF: 'afghan',
            AX: 'aland-island',
            AL: 'albanian',
            DZ: 'algerian',
            AS: 'american-samoan',
            AD: 'andorran',
            AO: 'angolan',
            AI: 'anguillan',
            AQ: 'antarctic',
            AG: 'antiguan',
            AR: 'argentine',
            AM: 'armenian',
            AW: 'aruban',
            AU: 'australian',
            AT: 'austrian',
            AZ: 'azerbaijani',
            BS: 'bahamian',
            BH: 'bahraini',
            BD: 'bangladeshi',
            BB: 'barbadian',
            BY: 'belarusian',
            BE: 'belgian',
            BZ: 'belizean',
            BJ: 'beninese',
            BM: 'bermudan',
            BT: 'bhutanese',
            BO: 'bolivian',
            BA: 'bosnian',
            BW: 'botswanan',
            BV: 'bouvet-island',
            BR: 'brazilian',
            IO: 'biot',
            BN: 'bruneian',
            BG: 'bulgarian',
            BF: 'burkinabe',
            BI: 'burundian',
            KH: 'cambodian',
            CM: 'cameroonian',
            CA: 'canadian',
            CV: 'cabo-verdean',
            KY: 'caymanian',
            CF: 'central-african',
            TD: 'Chadian',
            CL: 'chilean',
            CN: 'chinese',
            CX: 'christmas-island',
            CC: 'cocos-island',
            CO: 'colombian',
            KM: 'comoran',
            CD: 'drc-congolese',
            CG: 'congolese',
            CK: 'cook-island',
            CR: 'costa-rican',
            CI: 'ivorian',
            HR: 'croatian',
            CU: 'cuban',
            CY: 'cypriot',
            CZ: 'czech',
            DK: 'danish',
            DJ: 'djiboutian',
            DM: 'dominica',
            DO: 'dominican',
            EC: 'ecuadorian',
            EG: 'egyptian',
            SV: 'salvadoran',
            GQ: 'equatorial-guinean',
            ER: 'eritrean',
            EE: 'estonian',
            ET: 'ethiopian',
            FK: 'falkland-island',
            FO: 'faroese',
            FJ: 'fijian',
            FI: 'finnish',
            FR: 'french',
            GF: 'french-guianese',
            PF: 'french-polynesian',
            TF: 'french-southern-territories',
            GA: 'gabonese',
            GM: 'gambian',
            GE: 'georgian',
            DE: 'german',
            GH: 'ghanaian',
            GI: 'gibraltar',
            GR: 'greek',
            GL: 'greenlandic',
            GD: 'grenadian',
            GP: 'guadeloupe',
            GU: 'guamanian',
            GT: 'guatemalan',
            GG: 'sarnian',
            GN: 'guinean',
            GW: 'bissau-guinean',
            GY: 'guyanese',
            HT: 'haitian',
            HM: 'heard-island',
            VA: 'vatican',
            HN: 'honduran',
            HK: 'hong-konger',
            HU: 'hungarian',
            IS: 'icelandic',
            IN: 'indian',
            ID: 'indonesian',
            IR: 'iranian',
            IQ: 'iraqi',
            IE: 'irish',
            IM: 'manx',
            IL: 'israeli',
            IT: 'italian',
            JM: 'jamaican',
            JP: 'japanese',
            JE: 'jersiais',
            JO: 'jordanian',
            KZ: 'kazakhstani',
            KE: 'kenyan',
            KI: 'i-Kiribati',
            KW: 'kuwaiti',
            KG: 'kyrgyzstani',
            LA: 'lao',
            LV: 'latvian',
            LB: 'lebanese',
            LS: 'basotho',
            LR: 'liberian',
            LY: 'libyan',
            LI: 'liechtensteiner',
            LT: 'lithuanian',
            LU: 'luxembourg',
            MO: 'macanese',
            MK: 'macedonian',
            MG: 'malagasy',
            MW: 'malawian',
            MY: 'malaysian',
            MV: 'maldivian',
            ML: 'malian',
            MT: 'maltese',
            MH: 'marshallese',
            MQ: 'martinican',
            MR: 'mauritanian',
            MU: 'mauritian',
            YT: 'mahoran',
            MX: 'mexican',
            MF: 'saint-martinoise',
            FM: 'micronesian',
            MD: 'moldovan',
            MC: 'monegasque',
            MN: 'mongolian',
            ME: 'montenegrin',
            MS: 'montserratian',
            MA: 'moroccan',
            MZ: 'mozambican',
            MM: 'myanma',
            NA: 'namibian',
            NR: 'nauruan',
            NP: 'nepalese',
            NL: 'dutch',
            AN: 'netherlands-antillean',
            NC: 'new-caledonian',
            NZ: 'new-zealander',
            NI: 'nicaraguan',
            NE: 'nigerien',
            NG: 'nigerian',
            NU: 'niuean',
            NF: 'norfolk-island',
            KP: 'north-korean',
            MP: 'northern-marianan',
            NO: 'norwegian',
            OM: 'omani',
            PK: 'pakistani',
            PW: 'palauan',
            PS: 'palestinian',
            PA: 'panamanian',
            PG: 'papuan',
            PY: 'paraguayan',
            PE: 'peruvian',
            PH: 'filipino',
            PN: 'pitcairn-island',
            PL: 'polish',
            PT: 'portuguese',
            PR: 'puerto-rican',
            QA: 'qatari',
            RE: 'reunionese',
            RO: 'romanian',
            RU: 'russian',
            RW: 'rwandan',
            SH: 'saint-helenian',
            KN: 'kittitian',
            LC: 'saint-lucian',
            PM: 'saint-pierrais',
            VC: 'saint-vincentian',
            WS: 'samoan',
            SM: 'sammarinese',
            ST: 'sao-tomean',
            SA: 'saudi',
            SN: 'senegalese',
            RS: 'serbian',
            SC: 'seychellois',
            SL: 'sierra-leonean',
            SG: 'singaporean',
            SK: 'slovak',
            SI: 'slovenian',
            SB: 'solomon-island',
            SO: 'somali',
            ZA: 'south-african',
            GS: 'south-georgia-island',
            KR: 'south-korean',
            ES: 'spanish',
            LK: 'sri-lankan',
            SD: 'sudanese',
            SR: 'surinamese',
            SJ: 'svalbard',
            SZ: 'swazi',
            SE: 'swedish',
            CH: 'swiss',
            SY: 'syrian',
            TW: 'taiwanese',
            TJ: 'tajikistani',
            TZ: 'tanzanian',
            TH: 'thai',
            TL: 'timorese',
            TG: 'togolese',
            TK: 'tokelauan',
            TO: 'tongan',
            TT: 'trinidadian',
            TN: 'tunisian',
            TR: 'turkish',
            TM: 'turkmen',
            TC: 'turks-and-caicos-island',
            TV: 'tuvaluan',
            UG: 'ugandan',
            UA: 'ukrainian',
            AE: 'emirati',
            GB: 'british',
            US: 'american',
            UM: 'us-minor-outlying-island',
            UY: 'uruguayan',
            UZ: 'uzbekistani',
            VU: 'ni-vanuatu',
            VE: 'venezuelan',
            VN: 'vietnamese',
            VG: 'british-virgin-island',
            VI: 'us-virgin-island',
            WF: 'wallisian',
            EH: 'sahrawi',
            YE: 'yemeni',
            ZM: 'zambian',
            ZW: 'zimbabwean',
          },
          gender: {
            M: 'male',
            F: 'female',
          },
        },
        medium: {
          collagists: 'collagists',
          digital: 'digital',
          draftspersons: 'draftspersons',
          installation: 'installation',
          painters: 'painters',
          photographers: 'photographers',
          printmakers: 'printmakers',
          sculptors: 'sculptors',
        },
        style: {
          abstract: 'abstract',
          'abstract-expressionism': 'abstract-expressionism',
          'art-deco': 'art-deco',
          cartoon: 'cartoon',
          'colour-field': 'colour-field',
          conceptual: 'conceptual',
          cubism: 'cubism',
          dada: 'dada',
          expressionistic: 'expressionistic',
          figurative: 'figurative',
          graphic: 'graphic',
          geometric: 'geometric',
          'geometric-abstract': 'geometric-abstract',
          illustrative: 'illustrative',
          impressionistic: 'impressionistic',
          'abstract-marble': 'abstract-marble',
          minimalistic: 'minimalistic',
          mosaic: 'mosaic',
          photorealism: 'photorealism',
          'pop-art': 'pop-art',
          realistic: 'realistic',
          stencil: 'stencil',
          'street-art': 'street-art',
          surrealist: 'surrealist',
        },
        region: {
          african: 'african',
          'north-american': 'north-american',
          'latin-american': 'latin-american',
          caribbean: 'caribbean',
          european: 'european',
          scandinavian: 'scandinavian',
          'easter-european': 'easter-european',
          asian: 'asian',
          'south-asian': 'south-asian',
          'middle-eastern': 'middle-eastern',
          oceanian: 'oceanian',
        },
        gender: {
          M: 'M',
          F: 'F',
        },
        stage: {
          new: 'new',
          emerging: 'emerging',
          established: 'established',
        },
        // $FlowFixMe
        born: {},
        sort: {
          alpha: 'alpha',
          latest: 'latest',
          popularity: 'popularity',
          featured: 'featured',
        },
      },
      collection: {
        medium: {
          collage: 'collage',
          drawings: 'drawings',
          installation: 'installation',
          paintings: 'paintings',
          photography: 'photography',
          prints: 'prints',
          sculpture: 'sculpture',
        },
        style: {
          abstract: 'abstract',
          'art-deco': 'art-deco',
          cartoon: 'cartoon',
          conceptual: 'conceptual',
          cubism: 'cubism',
          dada: 'dada',
          expressionistic: 'expressionistic',
          minimalistic: 'minimalistic',
          figurative: 'figurative',
          geometric: 'geometric',
          illustrative: 'illustrative',
          impressionistic: 'impressionistic',
          'pop-art': 'pop-art',
          realistic: 'realistic',
          'street-art': 'street-art',
          surrealist: 'surrealist',
        },
        subject: {
          architecture: 'architecture',
          botanical: 'botanical',
          celebrities: 'celebrities',
          documentary: 'documentary',
          'science-technology': 'science-technology',
          seascapes: 'seascapes',
          'transport-auto': 'transport-auto',
          typography: 'typography',
          urban: 'urban',
          maps: 'maps',
          food: 'food',
          animals: 'animals',
          cityscapes: 'cityscapes',
          fashion: 'fashion',
          landscapes: 'landscapes',
          nudes: 'nudes',
          'plants-flowers': 'plants-flowers',
          portraits: 'portraits',
          spirituality: 'spirituality',
          sports: 'sports',
          'still-life': 'still-life',
        },
      },
    },
  },
  'de-DE': {
    queryStringParams: {
      medium: 'medium',
      subMedium: 'unter-medium',
      orientation: 'ausrichtung',
      size: 'groesse',
      style: 'stil',
      subject: 'thema',
      subSubject: 'unter-thema',
      color: 'farbe',
      region: 'region',
      gender: 'geschlecht',
      stage: 'karrierephase',
      price: 'preis',
      practice: 'ueben',
      initial: 'name',
      ships: 'schiffe',
      born: 'nationalitaet',
      countries: 'laender',
      width: 'breite',
      height: 'hoehe',
      layout: 'layout',
      sort: 'sortieren',
    },
    filtersInUrl: {
      art: {
        inPath: {
          subMedium: {
            'digital-1': 'digital',
            'fabric-1': 'stoff',
            'ink-1': 'tinte',
            'paper-1': 'papier',
            'mixed-media-1': 'mixed-media',
            'mixed-media-2': 'mixed-media',
            'mixed-media-3': 'mixed-media',
          },
          subSubject: {
            'flower-1': 'blumen',
            'london-1': 'london',
            'new-york-1': 'new-york',
          },
        },
        price: {
          UP: 'oben',
        },
        color: {
          colourful: 'farbenfroh',
          'black-white': 'schwarz-weiss',
          white: 'weiss',
          grey: 'grau',
          black: 'schwarz',
          'maroon-neutral': 'neutral',
          orange: 'orange',
          yellow: 'gelb',
          green: 'gruen',
          blue: 'blau',
          purple: 'lila',
          pink: 'rosa',
          red: 'rot',
        },
        medium: {
          collage: 'collage',
          digital: 'digital',
          drawings: 'zeichnungen',
          installation: 'installation',
          paintings: 'gemaelde',
          photography: 'fotografie',
          prints: 'kunstdrucke',
          sculpture: 'skulpturen',
        },
        subMedium: {
          photo: 'foto',
          'mixed-media-2': 'mixed-media-2',
          oil: 'oel',
          digital: 'digital',
          screenprint: 'siebdruck',
          transfer: 'transferdruck',
          fabric: 'stoff',
          'fabric-1': 'stoff-1',
          'mixed-media-1': 'mixed-media-1',
          'paper-1': 'papier-1',
          chalk: 'kreide',
          charcoal: 'holzkohle',
          ink: 'tinte',
          'ink-1': 'tinte-1',
          pastel: 'pastell',
          pencil: 'bleistift',
          acrylic: 'acryl',
          airbrush: 'airbrush',
          gouache: 'gouache',
          tempera: 'tempera',
          watercolour: 'aquarell',
          'black-white': 'schwarz-weiss',
          crayon: 'buntstift',
          colour: 'farbe',
          'digital-1': 'digital-1',
          'mixed-media': 'mixed-media',
          encaustic: 'enkaustik',
          etching: 'radierung',
          lino: 'lino',
          lithograph: 'lithografie',
          marble: 'marmor',
          'mixed-media-3': 'mixed-media-3',
          mono: 'mono',
          woodcut: 'holzschnitt',
          bronze: 'bronze',
          ceramic: 'keramik',
          clay: 'ton',
          enamel: 'emaille',
          glass: 'glas',
          kinetic: 'kinetisch',
          metal: 'metall',
          paper: 'papier',
          pinhole: 'lochkamera',
          plastic: 'kunststoff',
          resin: 'harz',
          vector: 'vektor',
          wood: 'holz',
          stone: 'stein',
        },
        stage: {
          new: 'neues',
          emerging: 'nachwuchskuenstler',
          established: 'etablierte-kuenstler',
        },
        orientation: {
          L: 'landschaft',
          P: 'portrait',
          S: 'rechteckig',
        },
        style: {
          abstract: 'abstrakt',
          'abstract-expressionism': 'abstrakter-expressionismus',
          'abstract-marble': 'abstrakter-marmor',
          'art-deco': 'art-deco',
          cartoon: 'cartoon',
          conceptual: 'konzeptuell',
          'colour-field': 'farbfeld',
          cubism: 'kubismus',
          'geometric-abstract': 'geometrisch-abstrakt',
          dada: 'dadaismus',
          expressionistic: 'expressionistisch',
          graphic: 'grafisch',
          minimalistic: 'minimalistisch',
          mosaic: 'mosaik',
          figurative: 'figurativ',
          geometric: 'geometrisch',
          illustrative: 'illustrativ',
          impressionistic: 'impressionistisch',
          photorealism: 'fotorealismus',
          'pop-art': 'pop-art',
          realistic: 'realistisch',
          stencil: 'schablone',
          'street-art': 'street-art',
          surrealist: 'surrealistisch',
        },
        subject: {
          architecture: 'architektur',
          botanical: 'botanisch',
          celebrities: 'prominente',
          documentary: 'dokumentarfilm',
          'science-technology': 'wissenschaft-technologie',
          seascapes: 'meereslandschaften',
          'transport-auto': 'transportwesen-autos',
          typography: 'typografie',
          urban: 'urban',
          maps: 'karten',
          fantasy: 'fantasy',
          food: 'lebensmittel',
          abstract: 'abstrakt',
          animals: 'tiere',
          cityscapes: 'stadtansichten',
          fashion: 'mode',
          landscapes: 'landschaften',
          music: 'musik',
          nature: 'natur',
          nudes: 'akte',
          politics: 'politik',
          portraits: 'portraits',
          spirituality: 'spiritualitaet',
          sports: 'sport',
          'still-life': 'stillleben',
          underwater: 'unterwasser',
          wildlife: 'wildtiere',
        },
        subSubject: {
          bird: 'voegel',
          cat: 'katzen',
          cow: 'kuehe',
          dog: 'hunde',
          fish: 'fische',
          horse: 'pferde',
          'hong-kong': 'hongkong',
          'london-1': 'london-1',
          'new-york-1': 'new-york-1',
          paris: 'paris',
          singapore: 'singapur',
          beach: 'strand',
          rural: 'laendlich',
          sky: 'himmel',
          london: 'london',
          'new-york': 'new-york',
          flower: 'blumen',
          'flower-1': 'blumen-1',
          tree: 'baeume',
          leaves: 'blaetter',
          female: 'weiblich',
          male: 'maennlich',
          religion: 'religion',
          athletics: 'athletik',
          cycling: 'radfahren',
          football: 'fussball',
          food: 'lebensmittel',
          airplane: 'flugzeuge',
          bike: 'fahrraeder',
          car: 'autos',
          ship: 'schiffe',
          train: 'zuege',
          yacht: 'yacht',
        },
        sort: {
          ontherise: 'im-trend',
          latest: 'neuerscheinungen',
          alltimetop: 'am-beliebtesten',
          price: 'preis',
          default: 'default',
        },
        layout: {
          sq: 'rechteckig',
          fl: 'fluessig',
        },
      },
      artist: {
        inPath: {
          born: {
            AD: 'andorranisch',
            AE: 'emiratisch',
            AF: 'afghanisch',
            AG: 'antiguanisch',
            AI: 'anguillanisch',
            AL: 'albanisch',
            AM: 'armenisch',
            AN: 'niederlaendisch-antillianisch',
            AO: 'angolanisch',
            AQ: 'antarktisch',
            AR: 'argentinisch',
            AS: 'amerikanisch-samoanisch',
            AT: 'oesterreichisch',
            AU: 'australisch',
            AW: 'arubanisch',
            AX: 'aland-insel',
            AZ: 'aserbaidschanisch',
            BA: 'bosnisch',
            BB: 'barbadisch',
            BD: 'bangladeschisch',
            BE: 'belgisch',
            BF: 'burkinisch',
            BG: 'bulgarisch',
            BH: 'bahrainisch',
            BI: 'burundisch',
            BJ: 'beninisch',
            BM: 'bermudisch',
            BN: 'bruneiisch',
            BO: 'bolivianisch',
            BR: 'brasilianisch',
            BS: 'bahamisch',
            BT: 'bhutanisch',
            BV: 'von-der-bouvetinsel',
            BW: 'botsuanisch',
            BY: 'belarussisch',
            BZ: 'belizeanisch',
            CA: 'kanadisch',
            CC: 'von-der-kokos-insel',
            CD: 'drc-kongolesisch',
            CF: 'zentralafrikanisch',
            CG: 'kongolesisch',
            CH: 'schweizerisch',
            CI: 'ivorisch',
            CK: 'von-den-cookinseln',
            CL: 'chilenisch',
            CM: 'kamerunisch',
            CN: 'chinesisch',
            CO: 'kolumbianisch',
            CR: 'costa-ricanisch',
            CU: 'kubanisch',
            CV: 'kapverdisch',
            CX: 'von-der-weihnachtsinsel',
            CY: 'zypriotisch',
            CZ: 'tschechisch',
            DE: 'deutsch',
            DJ: 'dschibutisch',
            DK: 'daenisch',
            DM: 'dominica',
            DO: 'dominikanisch',
            DZ: 'algerisch',
            EC: 'ecuadorianisch',
            EE: 'estnisch',
            EG: 'aegyptisch',
            EH: 'sahrawisch',
            ER: 'eritreisch',
            ES: 'spanisch',
            ET: 'aethiopisch',
            FI: 'finnisch',
            FJ: 'fidschianisch',
            FK: 'von-den-falklandinseln',
            FM: 'mikronesisch',
            FO: 'faeroeisch',
            FR: 'franzoesisch',
            GA: 'gabunisch',
            GB: 'britisch',
            GD: 'grenadisch',
            GE: 'georgisch',
            GF: 'franzoesisch-guyanisch',
            GG: 'sarnisch',
            GH: 'ghanaisch',
            GI: 'gibraltar',
            GL: 'groenlaendisch',
            GM: 'gambisch',
            GN: 'guineisch',
            GP: 'aus-guadeloupe',
            GQ: 'aequatorialguineisch',
            GR: 'griechisch',
            GS: 'aus-suedgeorgien',
            GT: 'guatemaltekisch',
            GU: 'guamisch',
            GW: 'guinea-bissauisch',
            GY: 'guyanisch',
            HK: 'aus-hongkong',
            HM: 'von-der-insel-heard',
            HN: 'honduranisch',
            HR: 'kroatisch',
            HT: 'haitianisch',
            HU: 'ungarisch',
            ID: 'indonesisch',
            IE: 'irisch',
            IL: 'israelisch',
            IM: 'von-der-isle-of-man',
            IN: 'indisch',
            IO: 'biotisch',
            IQ: 'irakisch',
            IR: 'iranisch',
            IS: 'islaendisch',
            IT: 'italienisch',
            JE: 'jersiaisch',
            JM: 'jamaikanisch',
            JO: 'jordanisch',
            JP: 'japanisch',
            KE: 'kenianisch',
            KG: 'kirgisisch',
            KH: 'kambodschanisch',
            KI: 'i-kiribatisch',
            KM: 'komorisch',
            KN: 'kittitianisch',
            KP: 'nordkoreanisch',
            KR: 'suedkoreanisch',
            KW: 'kuwaitisch',
            KY: 'von-den-kaimaninseln',
            KZ: 'kasachisch',
            LA: 'laotisch',
            LB: 'libanesisch',
            LC: 'lucianisch',
            LI: 'liechtensteinisch',
            LK: 'srilankisch',
            LR: 'liberianisch',
            LS: 'basotho',
            LT: 'litauisch',
            LU: 'luxemburgisch',
            LV: 'lettisch',
            LY: 'libysch',
            MA: 'marokkanisch',
            MC: 'monegassisch',
            MD: 'moldawisch',
            ME: 'montenegrinisch',
            MF: 'saint-martinoise',
            MG: 'madagassisch',
            MH: 'marshallisch',
            MK: 'mazedonisch',
            ML: 'malisch',
            MM: 'myanmarisch',
            MN: 'mongolesisch',
            MO: 'macanesisch',
            MP: 'nordmarianisch',
            MQ: 'martinikanisch',
            MR: 'mauretanisch',
            MS: 'montserratisch',
            MT: 'maltesisch',
            MU: 'mauritisch',
            MV: 'maledivisch',
            MW: 'malawisch',
            MX: 'mexikanisch',
            MY: 'malaiisch',
            MZ: 'mosambikanisch',
            NA: 'namibischer',
            NC: 'neukaledonisch',
            NE: 'nigernisch',
            NF: 'von-der-norfolkinsel',
            NG: 'nigerianisch',
            NI: 'nicaraguanisch',
            NL: 'niederlaendisch',
            NO: 'norwegisch',
            NP: 'nepalesisch',
            NR: 'nauruisch',
            NU: 'niueanisch',
            NZ: 'neuseelaendisch',
            OM: 'omanisch',
            PA: 'panamaisch',
            PE: 'peruanisch',
            PF: 'franzoesisch-polynesisch',
            PG: 'papua',
            PH: 'philippinisch',
            PK: 'pakistanisch',
            PL: 'polnisch',
            PM: 'aus-saint-pierre',
            PN: 'von-den-pitcairninseln',
            PR: 'puerto-ricanisch',
            PS: 'palaestinensisch',
            PT: 'portugiesisch',
            PW: 'palauisch',
            PY: 'paraguayisch',
            QA: 'katarisch',
            RE: 'reunionesisch',
            RO: 'rumaenisch',
            RS: 'serbisch',
            RU: 'russisch',
            RW: 'ruandisch',
            SA: 'saudisch',
            SB: 'salomonisch',
            SC: 'seychellisch',
            SD: 'sudanesisch',
            SE: 'schwedisch',
            SG: 'singapurisch',
            SH: 'von-st-helena',
            SI: 'slowenisch',
            SJ: 'svalbardisch',
            SK: 'slowakisch',
            SL: 'sierra-leonisch',
            SM: 'sammarinesisch',
            SN: 'senegalesisch',
            SO: 'somalisch',
            SR: 'surinamisch',
            ST: 'sao-tomeisch',
            SV: 'salvadorianisch',
            SY: 'syrisch',
            SZ: 'eswatinisch',
            TC: 'von-den-turks-und-caicosinseln',
            TD: 'tschadisch',
            TF: 'von-den-franzoesischen-sued-territorien',
            TG: 'togolesisch',
            TH: 'thailaendisch',
            TJ: 'tadschikistanisch',
            TK: 'tokelauisch',
            TL: 'timoresisch',
            TM: 'turkmenisch',
            TN: 'tunesisch',
            TO: 'tonganisch',
            TR: 'tuerkisch',
            TT: 'aus-trinidad',
            TV: 'tuvaluisch',
            TW: 'taiwanesisch',
            TZ: 'tansanisch',
            UA: 'ukrainisch',
            UG: 'ugandisch',
            UM: 'von-den-us-minor-outlying-islands',
            US: 'amerikanisch',
            UY: 'uruguayisch',
            UZ: 'usbekisch',
            VA: 'vatikanisch',
            VC: 'vincentisch',
            VE: 'venezolanisch',
            VG: 'von-den-britischen-jungferninseln',
            VI: 'von-den-amerikanischen-jungferninsel',
            VN: 'vietnamesisch',
            VU: 'vanuatuisch',
            WF: 'wallisisch',
            WS: 'samoanisch',
            YE: 'jemenitisch',
            YT: 'mahoranisch',
            ZA: 'suedafrikanisch',
            ZM: 'sambisch',
            ZW: 'simbabwisch',
          },
          gender: {
            M: 'maennlich',
            F: 'weiblich',
          },
        },
        medium: {
          collagists: 'kollagist',
          digital: 'digitale-kuenstler',
          draftspersons: 'verfasser',
          installation: 'installationskuenstler',
          painters: 'maler',
          photographers: 'fotografen',
          printmakers: 'grafiker',
          sculptors: 'bildhauer',
        },
        style: {
          abstract: 'abstrakt',
          'abstract-expressionism': 'abstrakter-expressionismus',
          'art-deco': 'art-deco',
          cartoon: 'cartoon',
          'colour-field': 'farbfeld',
          conceptual: 'konzeptuell',
          cubism: 'kubismus',
          dada: 'dadaismus',
          expressionistic: 'expressionistisch',
          figurative: 'figurativ',
          graphic: 'grafisch',
          geometric: 'geometrisch',
          'geometric-abstract': 'geometrisch-abstrakt',
          illustrative: 'illustrativ',
          impressionistic: 'impressionistisch',
          'abstract-marble': 'abstrakter-marmor',
          minimalistic: 'minimalistisch',
          mosaic: 'mosaik',
          photorealism: 'fotorealismus',
          'pop-art': 'pop-art',
          realistic: 'realistisch',
          stencil: 'schablone',
          'street-art': 'street-art',
          surrealist: 'surrealistisch',
        },
        region: {
          african: 'afrikanisch',
          'north-american': 'nordamerikanisch',
          'latin-american': 'lateinamerikanisch',
          caribbean: 'karibisch',
          european: 'europaeisch',
          scandinavian: 'skandinavisch',
          'easter-european': 'osteuropaeisch',
          asian: 'asiatisch',
          'south-asian': 'suedasiatisch',
          'middle-eastern': 'nahoestlich',
          oceanian: 'ozeanisch',
        },
        gender: {
          M: 'M',
          F: 'W',
        },
        stage: {
          new: 'neues',
          emerging: 'nachwuchskuenstler',
          established: 'etablierte-kuenstler',
        },
        // $FlowFixMe
        born: {},
        sort: {
          alpha: 'alpha',
          latest: 'neueste',
          popularity: 'beliebte',
          featured: 'ausgewaehlte',
        },
      },
      collection: {
        medium: {
          collage: 'collage',
          drawings: 'zeichnungen',
          installation: 'installation',
          paintings: 'gemaelde',
          photography: 'fotografie',
          prints: 'kunstdrucke',
          sculpture: 'skulpturen',
        },
        style: {
          abstract: 'abstrakt',
          'art-deco': 'art-deco',
          cartoon: 'cartoon',
          conceptual: 'konzeptuell',
          cubism: 'kubismus',
          dada: 'dadaismus',
          expressionistic: 'expressionistisch',
          minimalistic: 'minimalistisch',
          figurative: 'figurativ',
          geometric: 'geometrisch',
          illustrative: 'illustrativ',
          impressionistic: 'impressionistisch',
          'pop-art': 'pop-art',
          realistic: 'realistisch',
          'street-art': 'street-art',
          surrealist: 'surrealistisch',
        },
        subject: {
          architecture: 'architektur',
          botanical: 'botanisch',
          celebrities: 'prominente',
          documentary: 'dokumentarfilm',
          'science-technology': 'wissenschaft-technologie',
          seascapes: 'meereslandschaften',
          'transport-auto': 'transportwesen-autos',
          typography: 'typografie',
          urban: 'urban',
          maps: 'karten',
          food: 'lebensmittel',
          animals: 'tiere',
          cityscapes: 'stadtansichten',
          fashion: 'mode',
          landscapes: 'landschaften',
          nudes: 'akte',
          'plants-flowers': 'pflanzen-blumen',
          portraits: 'portraits',
          spirituality: 'spiritualitaet',
          sports: 'sport',
          'still-life': 'stillleben',
        },
      },
    },
  },
  'fr-FR': {
    queryStringParams: {
      medium: 'moyen',
      subMedium: 'sous-moyen',
      orientation: 'orientation',
      size: 'dimensions',
      style: 'style',
      subject: 'sujet',
      subSubject: 'sous-sujet',
      color: 'couleur',
      region: 'region',
      gender: 'sexe',
      stage: 'scene',
      price: 'prix',
      practice: 'pratique',
      initial: 'initial',
      ships: 'origine',
      born: 'nes',
      countries: 'pays',
      width: 'largeur',
      height: 'hauteur',
      layout: 'disposition',
      sort: 'trier',
    },
    filtersInUrl: {
      art: {
        inPath: {
          subMedium: {
            'fabric-1': 'tissu',
            'ink-1': 'encre',
            'paper-1': 'papier',
            'mixed-media-1': 'technique-mixte',
            'mixed-media-2': 'technique-mixte',
            'mixed-media-3': 'technique-mixte',
          },
          subSubject: {
            'flower-1': 'fleur',
            'london-1': 'londres',
            'new-york-1': 'new-york',
          },
        },
        price: {
          UP: 'eleve',
        },
        color: {
          colourful: 'colore',
          'black-white': 'noir-blanc',
          white: 'blanc',
          grey: 'gris',
          black: 'noir',
          'maroon-neutral': 'marron',
          orange: 'orange',
          yellow: 'jaune',
          green: 'vert',
          blue: 'bleu',
          purple: 'violet',
          pink: 'rose',
          red: 'rouge',
        },
        medium: {
          collage: 'collage',
          digital: 'digital',
          drawings: 'dessins',
          installation: 'installation',
          paintings: 'peintures',
          photography: 'photographie',
          prints: 'edition',
          sculpture: 'sculpture',
        },
        subMedium: {
          photo: 'photo',
          'mixed-media-2': 'technique-mixte-2',
          oil: 'huile',
          digital: 'digital',
          screenprint: 'serigraphie',
          transfer: 'transfert',
          fabric: 'tissu',
          'fabric-1': 'tissu-1',
          'mixed-media-1': 'technique-mixte-1',
          'paper-1': 'papier-1',
          chalk: 'craie',
          charcoal: 'fusain',
          ink: 'encre',
          'ink-1': 'encre-1',
          pastel: 'pastel',
          pencil: 'crayon',
          acrylic: 'acrylique',
          airbrush: 'aerographe',
          gouache: 'gouache',
          tempera: 'tempera',
          watercolour: 'aquarelle',
          'black-white': 'noir-et-blanc',
          crayon: 'crayon-gras',
          colour: 'colore',
          'digital-1': 'numerique',
          'mixed-media': 'technique-mixte',
          encaustic: 'encaustique',
          etching: 'gravure',
          lino: 'lino',
          lithograph: 'lithographie',
          marble: 'marbre',
          'mixed-media-3': 'technique-mixte-3',
          mono: 'mono',
          woodcut: 'gravure-bois',
          bronze: 'bronze',
          ceramic: 'ceramique',
          clay: 'argile',
          enamel: 'email',
          glass: 'verre',
          kinetic: 'cinetique',
          metal: 'metal',
          paper: 'papier',
          pinhole: 'stenope',
          plastic: 'plastique',
          resin: 'resine',
          vector: 'vectoriel',
          wood: 'bois',
          stone: 'pierre',
        },
        stage: {
          new: 'nouveau',
          emerging: 'emergent',
          established: 'confirme',
        },
        orientation: {
          L: 'paysage',
          P: 'portrait',
          S: 'carre',
        },
        style: {
          abstract: 'abstrait',
          'abstract-expressionism': 'expressionnisme-abstrait',
          'abstract-marble': 'marbre-arbrait',
          'art-deco': 'art-deco',
          cartoon: 'dessin-anime',
          conceptual: 'conceptuel',
          'colour-field': 'colour-field',
          cubism: 'cubisme',
          'geometric-abstract': 'abstraction-geometrique',
          dada: 'dada',
          expressionistic: 'expressionniste',
          graphic: 'graphique',
          minimalistic: 'minimaliste',
          mosaic: 'mosaique',
          figurative: 'figuratif',
          geometric: 'geometrique',
          illustrative: 'illustration',
          impressionistic: 'impressionniste',
          photorealism: 'realisme-photographique',
          'pop-art': 'pop-art',
          realistic: 'realisme',
          stencil: 'pochoir',
          'street-art': 'street-art',
          surrealist: 'surrealiste',
        },
        subject: {
          architecture: 'architecture',
          botanical: 'botanique',
          celebrities: 'celebrites',
          documentary: 'documentaire',
          'science-technology': 'science-technologie',
          seascapes: 'paysage-marin',
          'transport-auto': 'transport-auto',
          typography: 'typographie',
          urban: 'urbain',
          maps: 'cartes',
          fantasy: 'fantastique',
          food: 'nourriture',
          animals: 'animaux',
          cityscapes: 'paysage-urbain',
          fashion: 'mode',
          landscapes: 'paysage',
          music: 'musique',
          nature: 'nature',
          nudes: 'nu',
          politics: 'politique',
          portraits: 'portrait',
          spirituality: 'spiritualite',
          sports: 'sport',
          'still-life': 'nature-morte',
          underwater: 'aquatique',
          wildlife: 'faune',
        },
        subSubject: {
          bird: 'oiseau',
          cat: 'chat',
          cow: 'vache',
          dog: 'chien',
          fish: 'poisson',
          horse: 'cheval',
          'hong-kong': 'hong-kong',
          'london-1': 'londres-1',
          'new-york-1': 'new-york-1',
          paris: 'paris',
          singapore: 'singapour',
          beach: 'plage',
          rural: 'campagne',
          sky: 'ciel',
          london: 'londres',
          'new-york': 'new-york',
          flower: 'fleur',
          'flower-1': 'fleur-1',
          tree: 'arbre',
          leaves: 'feuilles',
          female: 'femme',
          male: 'homme',
          religion: 'religion',
          athletics: 'athletisme',
          cycling: 'cyclisme',
          football: 'football',
          food: 'nourriture',
          airplane: 'avion',
          bike: 'velo',
          car: 'voiture',
          ship: 'navire',
          train: 'train',
          yacht: 'yacht',
        },
        sort: {
          ontherise: 'tendance',
          latest: 'dernieres-sorties',
          alltimetop: 'le-plus-populaires',
          price: 'prix',
          default: 'toutes-les-guvres',
        },
        layout: {
          sq: 'carre',
          fl: 'fluide',
        },
      },
      artist: {
        inPath: {
          born: {
            AD: 'andorrane',
            AE: 'emirienne',
            AF: 'afghane',
            AG: 'antiguaise',
            AI: 'anguillaise',
            AL: 'albanaise',
            AM: 'armenienne',
            AN: 'antilles-neerlandaises',
            AO: 'angolaise',
            AQ: 'antarctique',
            AR: 'argentine',
            AS: 'samoane-americaine',
            AT: 'autrichienne',
            AU: 'australienne',
            AW: 'arubaise',
            AX: 'alandaise',
            AZ: 'azerie',
            BA: 'bosnienne',
            BB: 'barbadienne',
            BD: 'bangladaise',
            BE: 'belge',
            BF: 'burkinabee',
            BG: 'bulgare',
            BH: 'bahreinienne',
            BI: 'burundaise',
            BJ: 'beninoise',
            BM: 'bermudienne',
            BN: 'bruneienne',
            BO: 'bolivienne',
            BR: 'bresilienne',
            BS: 'bahameenne',
            BT: 'bhoutanaise',
            BV: 'bouvetienne',
            BW: 'botswanaise',
            BY: 'bielorusse',
            BZ: 'belizienne',
            CA: 'canadienne',
            CC: 'cocoite',
            CD: 'drc-congolaise',
            CF: 'centrafricaine',
            CG: 'congolaise',
            CH: 'suisse',
            CI: 'ivoirienne',
            CK: 'cookienne',
            CL: 'chilienne',
            CM: 'camerounaise',
            CN: 'chinoise',
            CO: 'colombienne',
            CR: 'costaricaine',
            CU: 'cubaine',
            CV: 'cap-verdienne',
            CX: 'christmasienne',
            CY: 'chypriote',
            CZ: 'tcheque',
            DE: 'allemande',
            DJ: 'djiboutienne',
            DK: 'danoise',
            DM: 'dominiquaise',
            DO: 'dominicaine',
            DZ: 'algerienne',
            EC: 'equatorienne',
            EE: 'estonienne',
            EG: 'egyptienne',
            EH: 'sahraouie',
            ER: 'erythreenne',
            ES: 'espagnole',
            ET: 'ethiopienne',
            FI: 'finlandaise',
            FJ: 'fidjienne',
            FK: 'malouine',
            FM: 'micronesienne',
            FO: 'feroienne',
            FR: 'francaise',
            GA: 'gabonaise',
            GB: 'britannique',
            GD: 'grenadienne',
            GE: 'georgienne',
            GF: 'guyanaise',
            GG: 'guernesiaise',
            GH: 'ghanéenne',
            GI: 'gibraltarienne',
            GL: 'groenlandaise',
            GM: 'gambienne',
            GN: 'guineenne',
            GP: 'guadeloupeenne',
            GQ: 'equato-guineenne',
            GR: 'grecque',
            GS: 'sud-georgien',
            GT: 'guatemalteque',
            GU: 'guamienne',
            GW: 'bissau-guineenne',
            GY: 'guyanienne',
            HK: 'hongkongaise',
            HM: 'heardienne-et-macdonaldienne',
            HN: 'hondurienne',
            HR: 'croate',
            HT: 'haitienne',
            HU: 'hongroise',
            ID: 'indonesienne',
            IE: 'irlandaise',
            IL: 'israelienne',
            IM: 'mannoise',
            IN: 'indienne',
            IO: 'biotienne',
            IQ: 'iraquienne',
            IR: 'iranienne',
            IS: 'islandaise',
            IT: 'italienne',
            JE: 'jerseyaise',
            JM: 'jamaicaine',
            JO: 'jordanienne',
            JP: 'japonaise',
            KE: 'kenyane',
            KG: 'kirghize',
            KH: 'cambodgienne',
            KI: 'kiribatienne',
            KM: 'comorienne',
            KN: 'saint-kittienne-et-niortaise',
            KP: 'nord-coreenne',
            KR: 'sud-coreenne',
            KW: 'koweitienne',
            KY: 'caimanaise',
            KZ: 'kazakhstanaise',
            LA: 'laotienne',
            LB: 'libanaise',
            LC: 'sainte-lucienne',
            LI: 'liechtensteinoise',
            LK: 'sri-lankaise',
            LR: 'liberienne',
            LS: 'lesothane',
            LT: 'lituanienne',
            LU: 'luxembourgeoise',
            LV: 'lettonne',
            LY: 'libyenne',
            MA: 'marocaine',
            MC: 'monegasque',
            MD: 'moldave',
            ME: 'montenegrine',
            MF: 'saint-martinoise',
            MG: 'malgache',
            MH: 'marshallaise',
            MK: 'macedonienne',
            ML: 'maliennes',
            MM: 'birmane',
            MN: 'mongole',
            MO: 'macaonaise',
            MP: 'mariannaise',
            MQ: 'martiniquaise',
            MR: 'mauritanienne',
            MS: 'montserratienne',
            MT: 'maltaise',
            MU: 'mauricienne',
            MV: 'maldivienne',
            MW: 'malawienne',
            MX: 'mexicaine',
            MY: 'malaisienne',
            MZ: 'mozambicaine',
            NA: 'namibienne',
            NC: 'neo-caledonienne',
            NE: 'nigerienne',
            NF: 'norfolkaise',
            NG: 'nigeriane',
            NI: 'nicaraguayenne',
            NL: 'neerlandaise',
            NO: 'norvegienne',
            NP: 'nepalaise',
            NR: 'nauruane',
            NU: 'niueenne',
            NZ: 'neo-zelandaise',
            OM: 'omanaise',
            PA: 'panameenne',
            PE: 'peruvienne',
            PF: 'polynesienne',
            PG: 'papouane-neo-guineenne',
            PH: 'philippine',
            PK: 'pakistanaise',
            PL: 'polonaise',
            PM: 'saint-pierraise-et-miquelonnaise',
            PN: 'pitcairnaise',
            PR: 'portoricaine',
            PS: 'palestinienne',
            PT: 'portugaise',
            PW: 'palaosienne',
            PY: 'paraguayenne',
            QA: 'qatarie',
            RE: 'reunionnaise',
            RO: 'roumaine',
            RS: 'serbe',
            RU: 'russe',
            RW: 'rwandaise',
            SA: 'saoudienne',
            SB: 'solomonaise',
            SC: 'seychelloise',
            SD: 'soudanaise',
            SE: 'suedoise',
            SG: 'singapourienne',
            SH: 'saint-helenienne',
            SI: 'slovene',
            SJ: 'svalbarde',
            SK: 'slovaque',
            SL: 'sierra-leonaise',
            SM: 'saint-marinaise',
            SN: 'senegalaise',
            SO: 'somalienne',
            SR: 'surinamaise',
            ST: 'santomeenne',
            SV: 'salvadorienne',
            SY: 'syrienne',
            SZ: 'swazie',
            TC: 'iles-turks-et-caicos',
            TD: 'tchadien',
            TF: 'terres-australes-et-antarctiques-francaises',
            TG: 'togolaise',
            TH: 'thailandaise',
            TJ: 'tadjike',
            TK: 'tokelauane',
            TL: 'timoraise',
            TM: 'turkmene',
            TN: 'tunisienne',
            TO: 'tonguienne',
            TR: 'turque',
            TT: 'trinidadienne',
            TV: 'tuvaluane',
            TW: 'taiwanaise',
            TZ: 'tanzanienne',
            UA: 'ukrainienne',
            UG: 'ougandaise',
            UM: 'iles-mineures-eloignees-des-etats-unis',
            US: 'americaine',
            UY: 'uruguayenne',
            UZ: 'ouzbek',
            VA: 'vaticane',
            VC: 'saint-vincentaise-et-grenadine',
            VE: 'venezuelienne',
            VG: 'ile-vierge-britannique',
            VI: 'ile-vierge-americaine',
            VN: 'vietnamienne',
            VU: 'vanuatuane',
            WF: 'wallisienne-et-futunienne',
            WS: 'samoane',
            YE: 'yemenite',
            YT: 'mahoraise',
            ZA: 'sud-africaine',
            ZM: 'zambienne',
            ZW: 'zimbabweenne',
          },
          gender: {
            M: 'homme',
            F: 'femme',
          },
        },
        medium: {
          collagists: 'collagistes',
          digital: 'artistes-digital',
          draftspersons: 'dessinateurs',
          installation: 'artistes-installation',
          painters: 'peintres',
          photographers: 'photographes',
          printmakers: 'graveurs',
          sculptors: 'sculpteurs',
        },
        style: {
          abstract: 'abstrait',
          'abstract-expressionism': 'expressionnisme-abstrait',
          'art-deco': 'art-deco',
          cartoon: 'dessin-anime',
          'colour-field': 'colour-field',
          conceptual: 'conceptuel',
          cubism: 'cubisme',
          dada: 'dada',
          expressionistic: 'expressionnisme',
          figurative: 'figuratif',
          graphic: 'graphique',
          geometric: 'geometrique',
          'geometric-abstract': 'abstraction-geometrique',
          illustrative: 'illustration',
          impressionistic: 'impressionnisme',
          'abstract-marble': 'marbre-abstrait',
          minimalistic: 'minimaliste',
          mosaic: 'mosaique',
          photorealism: 'realisme-photographique',
          'pop-art': 'pop-art',
          realistic: 'realisme',
          stencil: 'pochoir',
          'street-art': 'street-art',
          surrealist: 'surrealiste',
        },
        region: {
          african: 'africain',
          'north-american': 'nord-americain',
          'latin-american': 'latino-americain',
          caribbean: 'caribeen',
          european: 'europeen',
          scandinavian: 'scandinave',
          'easter-european': 'europeen-de-l-est',
          asian: 'asiatique',
          'south-asian': 'sud-asiatique',
          'middle-eastern': 'moyen-oriental',
          oceanian: 'oceanien',
        },
        gender: {
          M: 'H',
          F: 'F',
        },
        stage: {
          new: 'nouveau',
          emerging: 'emergent',
          established: 'confirme',
        },
        // $FlowFixMe
        born: {},
        sort: {
          alpha: 'alpha',
          latest: 'nouveaux',
          popularity: 'populaires',
          featured: 'vedette',
        },
      },
      collection: {
        medium: {
          collage: 'collage',
          drawings: 'dessins',
          installation: 'installation',
          paintings: 'peintures',
          photography: 'photographie',
          prints: 'edition',
          sculpture: 'sculpture',
        },
        style: {
          abstract: 'abstrait',
          'art-deco': 'art-deco',
          cartoon: 'dessin-anime',
          conceptual: 'conceptuel',
          cubism: 'cubisme',
          dada: 'dada',
          expressionistic: 'expressionniste',
          minimalistic: 'minimaliste',
          figurative: 'figuratif',
          geometric: 'geometrique',
          illustrative: 'illustration',
          impressionistic: 'impressionniste',
          'pop-art': 'pop-art',
          realistic: 'realisme',
          'street-art': 'street-art',
          surrealist: 'surrealiste',
        },
        subject: {
          architecture: 'architecture',
          botanical: 'botanique',
          celebrities: 'celebrites',
          documentary: 'documentaire',
          'science-technology': 'science-technologie',
          seascapes: 'paysage-marin',
          'transport-auto': 'transport-auto',
          typography: 'typographie',
          urban: 'urbain',
          maps: 'cartes',
          food: 'nourriture',
          animals: 'animaux',
          cityscapes: 'paysage-urbain',
          fashion: 'mode',
          landscapes: 'paysage',
          nudes: 'nu',
          'plants-flowers': 'plantes-fleurs',
          portraits: 'portrait',
          spirituality: 'spiritualite',
          sports: 'sport',
          'still-life': 'nature-morte',
        },
      },
    },
  },
};
